import "./StrategicPillars.module.css";
import Header from "@/reusable_sections/Header";
import OurExpertise from "./sections/OurExpertise";
import CoreSolutions from "./sections/CoreSolutions";
import FutureReadiness from "./sections/FutureReadiness";
import Footer from "@/reusable_sections/Footer";
export default function StrategicPillarsPage() {
  return <div>
      <Header />
      <OurExpertise />
      <CoreSolutions />
      <FutureReadiness />
      <Footer />
    </div>;
}